import React from 'react';
import { IconComponent } from '@src/icons';

// 密碼強度標籤內容：非「弱」時，前面帶一個對應顏色的打勾 icon（取代原本內嵌在文字裡的 ✓ 字元），
// 之後接強度文字。文字顏色沿用外層容器（= strength.color）；字級固定 14px，
// 綠色（好/強）用 weight 400、紅色（弱）視為錯誤字用 weight 500。icon 顏色沿用 strength.color。
const PasswordStrengthText = ({ strength }) => {
  if (!strength) {
    return null;
  }

  const isWeak = strength.type === 'weak';

  return (
    <span style={{ fontSize: 14, fontWeight: isWeak ? 500 : 400 }}>
      {!isWeak && (
        <IconComponent
          icon="login_form_check"
          color={strength.color}
          size={12}
          style={{ marginRight: 4, verticalAlign: 'middle', position: 'relative', top: -2 }}
        />
      )}
      {strength.message}
    </span>
  );
};

export default PasswordStrengthText;
